var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"render"}},[(_vm.isDay)?_c('img',{attrs:{"src":require("../assets/img/banner1.jpg")}}):_vm._e(),(!_vm.isDay)?_c('img',{attrs:{"src":require("../assets/img/banner2.jpg")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }